// extracted by mini-css-extract-plugin
export default {"itemsList":"Favorite_itemsList__3xtMN"};